import Vue from 'vue'
import Vuex from 'vuex'
import { router } from '@/router/index'
import {routers} from '../router/router'
Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    // imgUrl: 'http://192.168.9.151:7080/e_shop',
    // RequestUrl:'http://123.57.208.137:6386', // 正式

    ExcelUrl: 'https://more.jiankangplus.com.cn/api',
    //ExcelUrl: 'http://192.168.2.110:6386',



    routerCatalog: [] ,

    goodsId:{},
    goodsType:'',
    SecodeGodsId:{},
    threeGodsId:{},

    GoodsLcType:'',

    orderDate:{},
    setAddFirstFw:[],
  },
  mutations: {
    routerCatalog_add (state, value) {
      routers.forEach(item => {
        if (item.name === 'home') {
          item.children.push(...value)
        }
      })
      state.routerCatalog = value
      router.addRoutes(routers)
    },

    setGoodsType(state,data){
         state.goodsType = data
    },

    setOrderDate(state,data){
        state.orderDate = data
    },

    setAddFirstFw(state, List){
         state.firstFwList = List
    },
    setImmediateGodsId(state,data){
         state.goodsId = data
    },
    setSecondGoodsId(state,data){
         state.SecodeGodsId = data
    },
    setThreeGoodsId(state,data){
        state.threeGodsId = data
    },
    setAttrLctype(state,val){
         state.GoodsLcType = val
    }

  }
})
export default store









// WEBPACK FOOTER //
// ./src/Store/Store.js